// extracted by mini-css-extract-plugin
module.exports = {"fade-in-right":"animations_fade-in-right__bAHwu","fade-out-left":"animations_fade-out-left__1Z02H"};